"use client";

import { JobEntity as BaseJobEntity } from "./JobEntity";
import type { JobEntityProps } from "./JobEntity.types";

type PresetProps = Omit<JobEntityProps, "layout" | "density" | "actions"> & {
  actions?: JobEntityProps["actions"];
};

export function JobFeed(props: PresetProps) {
  return (
    <BaseJobEntity
      layout="card"
      density="comfortable"
      actions={{ apply: true, contactHiringManager: true, ...props.actions }}
      {...props}
    />
  );
}

export function JobSearch(props: PresetProps) {
  return (
    <BaseJobEntity
      layout="card"
      density="comfortable"
      actions={{
        apply: true,
        contactHiringManager: true,
        viewDetails: true,
        ...props.actions,
      }}
      {...props}
    />
  );
}

export function JobCompact(props: PresetProps) {
  return (
    <BaseJobEntity
      layout="row"
      density="compact"
      actions={{ apply: true, contactHiringManager: true, ...props.actions }}
      {...props}
    />
  );
}
